// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsData } from './EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsData.gen';
import type { EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsErrors } from './EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsErrors.gen';
import type { EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsResponses } from './EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsResponses.gen';
import type { EshopElectronicWalletTransactionControllerGetVehicleTicketsData } from './EshopElectronicWalletTransactionControllerGetVehicleTicketsData.gen';
import type { EshopElectronicWalletTransactionControllerGetVehicleTicketsErrors } from './EshopElectronicWalletTransactionControllerGetVehicleTicketsErrors.gen';
import type { EshopElectronicWalletTransactionControllerGetVehicleTicketsResponses } from './EshopElectronicWalletTransactionControllerGetVehicleTicketsResponses.gen';
import type { EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletData } from './EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletData.gen';
import type { EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletErrors } from './EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletErrors.gen';
import type { EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletResponses } from './EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletResponses.gen';
import type { Options } from './Options.gen';

export class EshopElectronicWalletTransactionController {
    /**
     * Get e-wallets transaction list.
     */
    public static getCustomerEWalletsTransactions<ThrowOnError extends boolean = false>(options?: Options<EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsResponses, EshopElectronicWalletTransactionControllerGetCustomerEWalletsTransactionsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/electronic-wallet-transactions',
            ...options
        });
    }
    
    /**
     * Get tickets from a transaction made in a vehicle.
     *
     * Returns an empty array if the transaction was not made in a vehicle.
     */
    public static getVehicleTickets<ThrowOnError extends boolean = false>(options: Options<EshopElectronicWalletTransactionControllerGetVehicleTicketsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopElectronicWalletTransactionControllerGetVehicleTicketsResponses, EshopElectronicWalletTransactionControllerGetVehicleTicketsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/electronic-wallet-transactions/{id}/vehicle-tickets',
            ...options
        });
    }
    
    /**
     * Short term tickets pay by wallet
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **INVALID_ELECTRONIC_WALLET** - Electronic wallet does not exist.<br>
     * + **INVALID_ELECTRONIC_WALLET_OPERATION** - Electronic wallet operation does not exist or is not allowed.<br>
     * + **NOT_ENOUGH_MONEY** - Not enough money to process the operation.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_CUSTOMER_VIRTUAL_CARD** - Customer card must be virtual for pay short term tickets by e-wallet.<br>
     * + **EWALLET_TRANSACTION_PAY_BY_WALLET_NOT_ALLOWED** - Short term tickets setting is not allowed in system configuration.
     */
    public static payShortTermTicketsByWallet<ThrowOnError extends boolean = false>(options: Options<EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletData, ThrowOnError>) {
        return (options.client ?? client).post<EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletResponses, EshopElectronicWalletTransactionControllerPayShortTermTicketsByWalletErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/electronic-wallet-transactions-pay-by-wallet',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
